import { X } from "lucide-react";
import suporterImage from "@/assets/images/sponsorship/suporter.png";
import { CreateRecommendationForm } from "@/features/sponsorship/components/CreateRecommendationForm";
import { Modal } from "@/shared/ui/atelier/Modal";

type RecommendationFormModalProps = {
  open: boolean
  onClose: () => void
  remainingRecommendations: number
};

/**
 * Recommendation form presented in a modal with a glassmorphism gutter around a
 * solid card, an illustrated (gradient + Yeti) header, and a fade-in + slide-in
 * entrance inherited from the Atelier Modal. Closes itself on successful submit.
 */
export const RecommendationFormModal = ({
  open,
  onClose,
  remainingRecommendations,
}: RecommendationFormModalProps) => (
  <Modal
    open={open}
    onClose={onClose}
    size="lg"
    aria-labelledby="recommendation-modal-title"
    className="max-w-3xl"
    // Neutralize the Atelier panel's solid surface so the glass gutter shows the
    // blurred backdrop through it (inline style beats the utility classes).
    style={{ background: "transparent", boxShadow: "none", padding: 0 }}
  >
    {/* Glassmorphism gutter (20px) */}
    <div className="rounded-[2rem] border border-white/40 bg-white/20 p-5 shadow-2xl backdrop-blur-xl dark:border-white/15 dark:bg-white/10">
      {/* Solid inner card */}
      <div className="flex max-h-[86dvh] flex-col overflow-hidden rounded-3xl bg-white dark:bg-gray-800">
        {/* Illustrated header */}
        <div className="sponsorship-ticket-gradient relative h-32 shrink-0 overflow-hidden">
          <img
            src={suporterImage}
            alt=""
            aria-hidden
            className="pointer-events-none absolute -bottom-3 right-4 h-40 select-none object-contain drop-shadow-xl"
          />
          <div className="relative z-10 flex h-full flex-col justify-center px-7">
            <h2 id="recommendation-modal-title" className="text-2xl font-bold text-white">
              Recommander un CSE
            </h2>
            <p className="mt-1 text-sm text-white/85">
              On s'occupe du reste. Vous êtes informé à chaque étape.
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            aria-label="Fermer"
            className="absolute right-3 top-3 z-20 flex h-8 w-8 items-center justify-center rounded-full bg-white/20 text-white backdrop-blur transition-colors hover:bg-white/30"
          >
            <X size={18} />
          </button>
        </div>

        {/* Scrollable form area */}
        <div className="overflow-y-auto px-7 py-6">
          <CreateRecommendationForm
            remainingRecommendations={remainingRecommendations}
            onSuccess={onClose}
          />
        </div>
      </div>
    </div>
  </Modal>
);

RecommendationFormModal.displayName = "RecommendationFormModal";
